/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.content-center {
  @apply mx-auto text-center;
}

.content-left {
  @apply mr-auto text-left;
}

.cards-wrapper {
  @apply grid grid-cols-2 w-full gap-12px md:gap-20px lg:gap-32px ;
}

.card {
  @apply rounded-xl relative;
}

.card .card-top {
  @apply rounded-t-xl w-full fs-7 py-40px relative z-10;
  /* background-image:radial-gradient(closest-side at 25% 25%,#c39f76 80%,#0000 81%),
  radial-gradient(closest-side at 75% 75%,#c39f76 80%,#0000 81%);
  background-size: 100px 100px; */


}
/* Custom Colors for mask */
.card .card-top .card-top-overlay {
  @apply absolute w-full h-full top-0 left-0 rounded-r-xl;
  mask-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/color-icons/metric-card-background.svg');
  mask-size: cover;
  mask-repeat: no-repeat;
  mask-position: center;
}

.card .card-top .card-top-overlay.mbg-light-blue {
  @apply bg-dark-blue opacity-30;
}

.card .card-top .card-top-overlay.mbg-medium-blue {
  @apply bg-light-blue opacity-30;
}

.card .card-top .card-top-overlay.mbg-dark-blue {
  @apply bg-light-blue opacity-30;
}

.card .card-top .card-top-overlay.mbg-orange {
  @apply bg-yellow opacity-30;
}

.card .card-top .card-top-overlay.mbg-yellow {
  @apply bg-orange opacity-30;
}

.card .card-top .card-top-overlay.mbg-light-green {
  @apply bg-dark-green opacity-30;
}

.card .card-top .card-top-overlay.mbg-dark-green {
  @apply bg-light-green opacity-30;
}

.card .card-top .card-top-overlay.mbg-maroon {
  @apply bg-red opacity-30;
}

.card .card-top .card-top-overlay.mbg-red {
  @apply bg-maroon opacity-30;
}

.card .card-bottom {
  @apply bg-ui-gray-6 w-full rounded-b-xl p-12px md:p-24px fs-2 min-h-[100px]  grow;
}

.layout-6 {
  @apply sm:grid-cols-3  md:grid-cols-6;
}

.layout-5 {
  @apply sm:grid-cols-3  md:grid-cols-5;
}

.layout-4 {
  @apply md:grid-cols-4;
}

.layout-4 .card {
  @apply col-span-1;
}


.layout-3 {
  @apply grid-cols-1  sm:grid-cols-3;
}

.layout-3 .card {
  @apply col-span-1;
}

.layout-2 {
  @apply grid-cols-2;
}

.layout-2 .card {
  @apply flex-row col-span-1 h-[225px] rounded-xl;
}

.layout-2 .card .card-top,
.layout-1 .card .card-top {
  @apply rounded-l-xl rounded-r-none h-full flex justify-center items-center;
}

.layout-2 .card .card-bottom,
.layout-1 .card .card-bottom {
  @apply rounded-l-none rounded-r-xl h-full flex justify-center items-center;
}

.layout-2 .card {
  @apply h-full w-full;
}

.layout-1 {
  @apply grid-cols-1;
}

.layout-1 .card {
  @apply col-span-1  flex-row;
}

.layout-1 .card .card-bottom {
  @apply h-full w-full ;
}
/* Animations */
@keyframes fade-in {
  0% {
    opacity: 0.4;
  }
  100% {
    opacity: 0;

  }
}

.overlay1, .overlay2, .overlay3, .overlay4{
  @apply absolute bg-white w-full h-full top-0 left-0 z-20 opacity-50;
  /* filter: grayscale(100%); */
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: .5s;
}

.cards-wrapper.animate .overlay1 {
  animation-name: fade-in;
  animation-delay: 0s;
}

.cards-wrapper.animate .overlay2 {
  animation-name: fade-in;
  animation-delay: .15s;
}

.cards-wrapper.animate .overlay3 {
  animation-name: fade-in;
  animation-delay: .30s;
}

.cards-wrapper.animate .overlay4 {
  animation-name: fade-in;
  animation-delay: .45s;
}
